module.exports = __webpack_public_path__ + "static/img/dongguologo.28186b6c.jpg";